import { render, staticRenderFns } from "./OffSiteLocationForm.vue?vue&type=template&id=9cff75ac"
import script from "./OffSiteLocationForm.vue?vue&type=script&lang=js"
export * from "./OffSiteLocationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports